<template>
  <dv-percent-pond :key="refreshFlagKey" :config="pondConfig" style="width: 100%;height: 100%" :style="{'--num-show': option.attribute.numShow ? 'inline':'none'}" @click="clickHandler"/>
</template>

<script>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";

export default {
  name: "cpt-dataV-percentPond",
  props:{
    width:Number,
    height:Number,
    option:Object,
  components:Array
  },
  watch: {
    // 'option.attribute': {
    //   handler() {
    //      this.processData(this.option.cptDataForm,this.newData,this.jsFunFlag);
    //     // this.loadData(this.option.cptDataForm);
    //   },
    //   deep: true//深度监听
    // },
    width(){
      this.refreshFlagKey = require('uuid').v1();
    },
    height(){
      this.refreshFlagKey = require('uuid').v1();
    }
  },
  data() {
    return {
      uuid: null,
      pondConfig:{},
      refreshFlagKey: null, //强制刷新视图
      newData:"",
      jsFunFlag:false,
    }
  },
  mounted() {
    this.uuid = require('uuid').v1();
    this.refreshFlagKey = require('uuid').v1();
    this.refreshCptData(this.option.cptDataForm);
  },
  methods: {
    refreshCptData(cptDataForm) {
      pollingRefresh(this.uuid, cptDataForm, () => this.loadData(cptDataForm),
        this.components)
    },
    loadData(cptDataForm){
      const that = this;
      getDataJson(cptDataForm,'',(res)=> {
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        that.processData(cptDataForm,that.newData,that.jsFunFlag)
        // let tempConfig = JSON.parse(JSON.stringify(this.option.attribute));
        // tempConfig.value = res.value;
        // tempConfig.lineDash = [tempConfig.lineWidth, tempConfig.lineSpace]
        // this.pondConfig = tempConfig;
        // this.refreshFlagKey = require('uuid').v1(); //强制刷新视图 报错为dataV组件内部bug

      })
    },
    processData(cptDataForm,res,jsFunFlag){
       let cptData = '';
      // 第一层判断 如果选择数据集
      if(cptDataForm.dataSource == '4') {
        // 第二层判断 ，如果没有配转换脚本
        if(jsFunFlag) { // 没有全部配置映射字段
            if(hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
          // 创建一个新的数组用于存储结果
            let newres = [];
            let newObj = {...res[0]};
          // 如果dataKey中的value有值并且在newObj对象中有对应的值
            // if (dataKey[0].value && newObj[dataKey[0].value]) {
              newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            // }
            newres.push(newObj);
            // console.log(newres,'新数组');
            cptData = newres[0]; 
          }
          } else { // 如果配置了转换脚本
            cptData = res;
          }
      } else { // 不是数据集类型，是静态数据
        cptData = res;
      } 
        console.log(cptData,'cptData数据')
        let tempConfig = JSON.parse(JSON.stringify(this.option.attribute));
        tempConfig.value = cptData.value;
        tempConfig.lineDash = [tempConfig.lineWidth, tempConfig.lineSpace]
        this.pondConfig = tempConfig;
        this.refreshFlagKey = require('uuid').v1(); //强制刷新视图 报错为dataV组件内部bug
    },
    clickHandler(){
      this.$emit("clickHandler",this.option.interaction)
    }
  }
}
</script>

<style scoped>
.dv-percent-pond /deep/ text{display: var(--num-show)}
</style>
